import { render } from "./itembar.vue?vue&type=template&id=09d1e35e&scoped=true"
import script from "./itembar.vue?vue&type=script&lang=js"
export * from "./itembar.vue?vue&type=script&lang=js"

import "./itembar.vue?vue&type=style&index=0&id=09d1e35e&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d1e35e"]])

export default __exports__